import styled from 'styled-components';

export const SectionTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 12px;
  font: inherit;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;
